<template>
    <div v-resize="onResize" class="fill-height" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
            show-arrows
        >
            <v-tab
                :to="{
                    name: isOperatorContext ? 'operator-ncCodes' : 'ncCodes',
                    params: { setting: ncCodesSettings },
                }"
            >
                NC Codes
            </v-tab>
            <v-tab
                :to="{
                    name: isOperatorContext
                        ? 'operator-rejection-reasons'
                        : 'rejection-reasons',
                    params: { setting: ncCodesSettings },
                }"
            >
                Rejection Reasons
            </v-tab>
        </v-tabs>
        <v-card :loading="loading" flat>
            <v-card-title ref="title"> </v-card-title>

            <v-card-subtitle ref="subtitle" class="my-0">
                <v-divider />
            </v-card-subtitle>

            <v-card-text
                class="overflow-y-auto"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'QualitySettings',
    components: {},
    props: {
        setting: Object,
    },
    data() {
        return {
            height: 0,
            loading: false,
            error: null,
            errorMsg: null,
            companyId: JSON.parse(localStorage.getItem('company')),
            ncCodesSettings: {},
        }
    },
    computed: {
        isOperatorContext() {
            // Detect if we are in operator-settings context
            return this.$route.path.includes('/operator-settings')
        },
    },
    updated() {
        this.onResize()
    },
    created() {
        this.ncCodesSettings = this.setting.quality
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
                title: { clientHeight: titleHeight },
                subtitle: { clientHeight: subtitleHeight },
            } = this.$refs
            this.height =
                containerHeight - tabsHeight - titleHeight - subtitleHeight
        },
        show() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$emit('show')
            }
        },
    },
}
</script>
